var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A88752D7-C2B8-4BA5-BC74-0D0C00D15F23") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-3-Copy-17",
    transform: "translate(-936.000000, -4368.000000)",
    fill: "#17171B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook-(5)-copy",
    transform: "translate(936.000000, 4368.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3556462,0 L2.70296431,0 C1.21018805,0 0,1.20657059 0,2.69499395 L0,17.3045667 C0,18.7929901 1.21013898,19.9996585 2.70296431,19.9996585 L9.92959711,19.9996585 L9.94191343,12.8527997 L8.07969688,12.8527997 C7.83768871,12.8527997 7.64126562,12.6576897 7.64033331,12.4163951 L7.63140276,10.1126976 C7.63047044,9.87008206 7.82748237,9.67291721 8.0708154,9.67291721 L9.92964618,9.67291721 L9.92964618,7.44696033 C9.92964618,4.86375836 11.5119733,3.45718531 13.8231709,3.45718531 L15.7196867,3.45718531 C15.9623328,3.45718531 16.1590993,3.65332275 16.1590993,3.89530224 L16.1590993,5.83779184 C16.1590993,6.07967348 15.96248,6.275762 15.7199321,6.27590877 L14.5560651,6.27644694 C13.2991634,6.27644694 13.0557813,6.87195327 13.0557813,7.74588768 L13.0557813,9.67296614 L15.8176284,9.67296614 C16.0807853,9.67296614 16.2849613,9.90207854 16.2539497,10.1626493 L15.9800957,12.4663468 C15.9538929,12.6867996 15.7664004,12.8528976 15.5437744,12.8528976 L13.0680976,12.8528976 L13.0557813,19.9996585 L17.3557444,19.9996585 C18.8485206,19.9996585 20.0586596,18.7930879 20.0586596,17.3047135 L20.0586596,2.69499395 C20.0586596,1.20657059 18.8484715,0 17.3556462,0 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cdab715345bdb65d2c23b52739b5c01e.svg";
export { ForwardRef as ReactComponent };